import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { IInstance } from '../types/Instance'
import { mapInstances } from '../lib/mapInstances'
import { PaginatedData } from '../../../../shared/types/PaginatedData'

export const fetchInstancesAll = createAsyncThunk<
	Array<IInstance>,
	string,
	ThunkConfig<string>
>('instances/fetchInstancesAll', async (licenseId, thunkAPI) => {

	const { extra: { api }, rejectWithValue } = thunkAPI

	try {
		const res = await api.get<Array<IInstance>>(
			`/licenses/${licenseId}/instances/all`
		)

		const paginatedDataInstancesMapped = mapInstances({
			items: res.data
		} as PaginatedData<IInstance>)

		return paginatedDataInstancesMapped.items
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchInstances', 'Failed to fetch all license instances')
		return rejectWithValue('Error occurred on fetching all license instances')
	}
})
